import axios from 'axios';
import store from '../store';
import DEFINES from '@/defines';
import router from '@/router';

const HASH_ALGO = 'sha256';
const BASE_API_URL = DEFINES.BASE_API_URL;
const BUILD_MODE = process.env.VUE_APP_BUILD_MODE;
const BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION;

async function callApi (url, payload) {
  store.dispatch ('app/showLoader');
  return axios
    .post (BASE_API_URL + url, payload, buildHeaders ())
    .then (response => {
      return parseResponse (response);
    })
    .catch (error => {
      //catch axios errors
      if (error.response != undefined) {
        return parseHttpError (error.response);
      } else {
        //its rms server error data
        throw error;
      }
    })
    .finally (function () {
      store.dispatch ('app/hideLoader');
    });
}

const getSetCookieUrl = () => {
  return BASE_API_URL + '/stream/setCookie/' + JSON.stringify (getAuthHash ());
};

async function callGetReqApi (url, payload) {
  store.dispatch ('app/showLoader');
  return axios
    .get (BASE_API_URL + url, payload)
    .then (response => {
      return parseResponse (response);
    })
    .catch (error => {
      //catch axios errors
      if (error.response != undefined) {
        return parseHttpError (error.response);
      } else {
        //its rms server error data
        throw error;
      }
    })
    .finally (function () {
      store.dispatch ('app/hideLoader');
    });
}

async function handleError (error) {
  if (error) {
    // FIXME::Need to handle it properly
    /*
    In case of login link in OTP mail, invalid session raises the exception with 419 code that is existing flow
    which logouts the existing session. To prevent this, added a route based checking temporarily.
    */
    if (error.code == 419 && router.currentRoute.name != "company.verify") {
      await store.dispatch ('auth/logout');
      return;
    }
    store.dispatch ('app/showMessage', {
      message: error.message,
      color: 'error',
    });
  }
}

const buildHeaders = () => {
  return {
    headers: {
      Authorization: 'Bearer ' + JSON.stringify (getAuthHash ()),
    },
  };
};

const getAuthHash = () => {
  let nonce = require ('nonce') ();
  //FIXME: Implement Server Side Security
  let timestamp = '1' + nonce ();
  let key = store.state.auth.key;
  let secret = store.state.auth.secret;
  let screener_id = store.state.app.currentScreenerId;

  let signature = key + secret + timestamp;

  let hash = null;
  let language = store.getters['company/getCurrentCompanyLanguage'];

  if (key && secret) {
    hash = doHash (signature);
  }

  return {
    key: store.state.auth.key,
    timestamp: timestamp,
    hash: hash,
    version: BUILD_VERSION,
    build_mode: BUILD_MODE,
    language: language,
    screener_id: screener_id,
  };
};

const doHash = req => {
  let shajs = require ('sha.js');
  let hash = shajs (HASH_ALGO).update (req).digest ('hex');
  return hash;
};

const parseHttpError = response => {
  //server is down
  //console.log (response);
  let error = response.status + ' : ' + response.statusText;
  //FIXME: have to handle http error here status field is not received from api response
};

const parseResponse = response => {
  handleError (response.data.error);
  //2.  Non-handleable errors
  if (response.data.error) {
    throw response.data.error;
  }

  //3. Data is OK
  if (response.status == 200) {
    // check version
    if (
      BUILD_MODE == 'PRODUCTION' &&
      response.data.version != DEFINES.APP_VERSION
    ) {
      store.dispatch ('app/showMessage', {
        message: 'We are about to update the APP',
        color: 'success',
      });
      router.push ({
        name: router.currentRoute.name,
        query: {version: response.data.version},
      });
    }
    return response.data.data;
  }

  //4. Unknown Stage
  throw {
    title: 'Unknown API response',
  };
};

export {
  callApi,
  callGetReqApi,
  parseHttpError,
  buildHeaders,
  getAuthHash,
  getSetCookieUrl,
};
